export default class RequestError {
  constructor(status, message) {
    this.name = 'RequestError'
    this.status = status
    this.message = message || 'passport.error.server.default'
  }
}
